import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './Login.css';
import '../global.css';
import '../components/Theme.css';

const LoginPage = () => {
  return (
    <div className="app-container">
      
      <div className="left-panel">
          <img className="login-logo mb-4" src="./login-logo.png" alt="Logo" />
          <form className="login-form">
            <h3 className="h3 text-center">Sign In</h3>
            <div className="form-group mb-4">
              <input className="form-control input-lg"
                type="email"
                placeholder="Email"
                required
              />
            </div>

            <div className="form-group mb-4">
              <input className="form-control input-lg"
                type="password"
                placeholder="Password"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Login
            </button>

            {/* Display error message if any */}
            
          </form>
      </div>
      <div className="right-panel">
          {/* <h2 className="text-white">New here?</h2>
          <p className="text-white">Streamline Your Processes And Transform Your Business</p>
          <button className="btn btn-info">Sign Up</button> */}
      </div>
    </div>
  );
};

export default LoginPage;
